module.exports = __webpack_public_path__ + "assets/img/02.b421cf13.png";